import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { key: 0 }


export default /*@__PURE__*/_defineComponent({
  __name: 'Form',
  props: {
  model: {
    type: Object,
    required: true
  },
  hideErrors: {
    type: Boolean,
    default: false
  },
  display: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  },
  noOverlay: {
    type: Boolean,
    default: false
  }
},
  setup(__props) {





provide('model', computed(() => __props.model))
provide('disabled', computed(() => __props.model.locked || __props.disabled))
provide('display', computed(() => __props.display))

const showErrors = computed(() => !isEmpty(__props.model.errors) && !__props.hideErrors)


return (_ctx: any,_cache: any) => {
  const _component_v_overlay = _resolveComponent("v-overlay")!
  const _component_hy_alert = _resolveComponent("hy-alert")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!__props.noOverlay)
      ? (_openBlock(), _createBlock(_component_v_overlay, {
          key: 0,
          modelValue: __props.model.active,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((__props.model.active) = $event)),
          scrim: "primary",
          contained: "",
          persistent: "",
          class: "hy-form-overlay"
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (_unref(showErrors))
      ? (_openBlock(), _createBlock(_component_hy_alert, {
          key: 1,
          type: "error",
          class: "mb-4"
        }, {
          default: _withCtx(() => [
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.model.errors as Record<string, string[]>, (errors, field) => {
                return (_openBlock(), _createElementBlock("li", { key: field }, [
                  (field !== 'error')
                    ? (_openBlock(), _createElementBlock("strong", _hoisted_1, _toDisplayString(__props.model.field(field).label), 1))
                    : _createCommentVNode("", true),
                  _createTextVNode(" • " + _toDisplayString(errors.join(', ')), 1)
                ]))
              }), 128))
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default")
  ], 64))
}
}

})